module.exports = __webpack_public_path__ + "97463d94c6200dd116bec8beaf9fdadd.svg";